<template>
    <div style="width: 90%; padding: 20px">
        <el-input
            style="width: 100%; font-size: 20px; margin-bottom: 20px;"
            placeholder="Título de la publicación"
            v-model="pubtitulo"
        ></el-input>
        <el-tiptap
            style="height: 70vh"
            v-model:content="contenidoEditor"
            :extensions="extensions"
        />
    </div>
</template>

<script>
import {
    Doc,
    Text,
    Paragraph,
    Heading,
    Bold,
    Italic,
    Strike,
    Underline,
    Link,
    Image,
    Iframe,
    CodeBlock,
    Blockquote,
    BulletList,
    OrderedList,
    TaskList,
    TextAlign,
    Indent,
    LineHeight,
    HorizontalRule,
    HardBreak,
    History,
    Table,
    FormatClear,
    Color,
    Highlight,
    Print,
    Fullscreen,
    SelectAll,
    FontFamily,
    FontSize,
    CodeView,
} from 'element-tiptap-vue3-fixed';
import { mapMutations, mapState } from 'vuex';

export default {
    name: 'WysiWyg',
    data() {
        return {
            loading: false,
            extensions: [
                Doc,
                Text,
                Paragraph,
                Heading.configure({ level: 5 }),
                Bold.configure({ bubble: true }),
                Underline.configure({ bubble: true, menubar: false }),
                Italic,
                Strike,
                BulletList,
                OrderedList,
                Link,
                Image,
                Iframe,
                CodeBlock,
                Blockquote,
                TaskList,
                TextAlign,
                Indent,
                LineHeight,
                HorizontalRule,
                HardBreak,
                History,
                Table,
                FormatClear,
                Color,
                Highlight,
                Print,
                Fullscreen,
                SelectAll,
                FontFamily,
                FontSize,
                CodeView,
            ],
        };
    },
    computed: {
        ...mapState(['content', 'pub_titulo']),
        contenidoEditor: {
            get() {
                return this.content;
            },
            set(value) {
                this.setContent(value);
            }
        },
        pubtitulo: {
            get() {
                return this.pub_titulo;
            },
            set(value) {
                this.setPubTitulo(value);
            }
        }
    },
    methods: {
        ...mapMutations(['setContent', 'setPubTitulo']),
    },
};
</script>

<style scoped lang="scss">
#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }
}
</style>
